import { types, actions } from './requests'
export const WRITESWA300CONFIG_TYPES = {
    ...types('WRITESWA300CONFIG'),
}
export const WRITESWA300CONFIG_ACTIONS = {
    ...actions('WRITESWA300CONFIG'),
}
